<template>
  <div>
    <Header ref="headerCom"></Header>
    <section>
      <div class="page_map" style="width: 80%;margin: auto;padding: 0px;">
        <ol class="breadcrumb">
          <li><router-link to="/">Home</router-link></li>
        </ol>
      </div>
      <div class="product_info_details" style="width:80%">
        <div class="product_info_title sTop" style="">Database Overview</div>
        <div style="text-align: center;"></div>
        <!-- <ul class="product_baseinfo">
          <li style="height:500px;">
            <label style="width:33%;"><v-echart :option="categoryOptions" ref="echart"></v-echart></label>
            <label style="width:34%;"><img src="../assets/center.png" style="width: 100%;height:auto;"/></label>
            <label style="width:33%;"><v-echart :option="TargetOptions" ref="echartTarget"></v-echart></label>
          </li>
        </ul> -->
        <div class="product_baseinfo" >
          <label style="margin-right: 10px;"><v-echart :option="categoryOptions" ref="echart"></v-echart></label>
          <label style="margin-right: 10px;"><v-echart :option="worldOptions" ref="wordechart"></v-echart></label>
            <!-- <label ><img src="../assets/center.png" style="width: 83%;padding: 10px;max-height: 500px;line-height: 500px; vertical-align: middle;"/></label> -->
            <label style="margin-left: 10px;"><v-echart :option="TargetOptions" ref="echartTarget"></v-echart></label>
        </div>
        <div class="backgroundT"></div>
        <div class="bottomS">
          <div class="bottomFirst">
            <span >Drug stage</span>
            <img src="../assets/icon1.png" style="width: 60px;"/>
          </div>
          <div class="bodyBottom">
            <span @click="getSearchContent('approved')">Approved</span>
            <span @click="getSearchContent('withdrawn')">Withdrawn</span>
            <span @click="getSearchContent('investigational')">Investigational</span>
            <span @click="getSearchContent('experimental')">Experimental</span>
            <span @click="getSearchContent('nutraceutical')">Nutraceutical</span>
            <span @click="getSearchContent('vet_approved')">vet_approved</span>
            <span @click="getSearchContent('illicit')">illicit</span>
          </div>
          <div class="bottomFirst">
            <span >Target type</span>
            <img src="../assets/icon2.png" style="width: 60px;"/>
          </div>
          <div class="bodyBottomT">
            <span @click="getSearchContent('Successful target')">Successful target</span>
            <span @click="getSearchContent('Literature-reported target')">Literature-reported target</span>
            <span @click="getSearchContent('Clinical trial target')">Clinical trial target </span>
            <span @click="getSearchContent('Discontinued target')">Discontinued target</span>
            <span @click="getSearchContent('Preclinical target')">Preclinical target</span>
            <span @click="getSearchContent('Patented-recorded target')">Patented-recorded target</span>
          </div>
        </div>
      </div>

    </section>

    <Footer ></Footer>
  </div>
</template>

<script>
import echarts from 'echarts'
import "echarts-wordcloud"
import Header from './header/Index.vue'
import Footer from './footer/Index.vue'
import api from './../axios/api.js'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      categoryOptions:{},
      TargetOptions:{},
      worldOptions:{},
      tjdata:[
      ],
      Targetdata:[
      ],
      radiooptions: [
        { text: '精确搜索', value: "exact" },
        { text: '子结构搜索', value: 'sub' },
        { text: '60%相似度结构搜索', value: 'similarity-0.6' },
        { text: '80%相似度结构搜索', value: 'similarity-0.8' },
        { text: '90%相似度结构搜索', value: 'similarity-0.9' }
      ],
      searchItem:["advancedValue1"],
      searchKeyword:[""],
      selected:["ALL"],
      butclick:2,
      radiocheck: "sub",
      worddata:[],
      targetdatatotle:0,
      keggKeydatatotle:0
    }
  },
  created() {
  },
  mounted: function () {
    let that = this;
    that.gettjData();
  },
  methods: {
    getSearchContent(val){
      var searchCon = {};
        searchCon.radiocheck = this.radiocheck;
        searchCon.radiooptions = this.radiooptions;
        searchCon.searchItem = this.radiooptions;
        searchCon.searchKeyword = this.searchKeyword;
        searchCon.searchtext = val;
        searchCon.selected = this.selected;
        searchCon.butclick = 2;
        var savepstr = JSON.stringify(searchCon);
        window.sessionStorage.setItem("searchCon", savepstr);
        this.$router.push({
          path: '/'
        })
    },
    renderPieChart () {
      var that=this;
      var mockData = this.tjdata;
      this.categoryOptions ={
                    title:{
                        text:'KEGG Drug type',
                        subtext:'',
                        x:'center',
                        y:'top',
                        textAlign:'left'
                    },
                    graphic:[
                        {
                            type:'text',
                            left:'center',
                            top:'42%',
                            z:10,
                            style:{
                                fill:'#fff',
                                fontSize:13,
                                align:'center',
                                text:'Totle'
                            }
                        },
                        {
                            type:'text',
                            left:'center',
                            top:'56%',
                            z:10,
                            style:{
                                fill:'#fff',
                                text:that.keggKeydatatotle,
                                fontSize:15,
                                textAlign:'center',
                                font: '30px Microsoft YaHei'
                            }
                        }
                    ],
                    series: [
                        {
                            color:['#888383'],
                            type: 'pie',
                            radius: '60%',
                            center:['50%','50%'],
                            data: [
                                {value: that.keggKeydatatotle, name: 'Totle'},
                            ],
                            emphasis: {
                                scale: false
                            },
                            label:{
                                show:false
                            }
                        },
                        {
                          itemStyle:{
                              borderWidth:1,
                              borderColor:'#fff'
                            },
                            type: 'pie',
                            radius: ['50%', '80%'],
                            center:['50%','50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                fontSize:12,
                                textAlign:'center',
                                formatter: `{b}: {c}`
                            },
                            labelLine: {
                                show: true,
                                length: 35,
                                length2: 10,
                            },
                            data: mockData
                        }
                    ]
                };
              var myChart = this.$refs.echart;
              myChart.chart.on('mouseover', function (params) {
                that.categoryOptions.graphic[0]['style']['text']=params.data.name.split(' ').join('\n');
                that.categoryOptions.graphic[1]['style']['text']=params.data.value;
              });
              myChart.chart.on('mouseout', function (params) {
                that.categoryOptions.graphic[0]['style']['text']='Totle';
                that.categoryOptions.graphic[1]['style']['text']=that.keggKeydatatotle;
              });
              myChart.chart.on('click', function (params) {
                if(params.name!="Totle"){
                that.getSearchContent(params.name);
                }
              });
    },
    renderTargetChart() {
      var that=this;
      var mockData = this.Targetdata;
      this.TargetOptions ={
                    title:{
                        text:'Target hierarchy',
                        subtext:'',
                        x:'center',
                        y:'top',
                        textAlign:'left'
                    },
                    graphic:[
                        {
                            type:'text',
                            left:'center',
                            top:'42%',
                            z:10,
                            style:{
                                fill:'#fff',
                                fontSize:13,
                                align:'center',
                                text:'Totle'
                            }
                        },
                        {
                            type:'text',
                            left:'center',
                            top:'56%',
                            z:10,
                            style:{
                                fill:'#fff',
                                text:that.targetdatatotle,
                                fontSize:15,
                                textAlign:'center',
                                font: '30px Microsoft YaHei'
                            }
                        }
                    ],
                    series: [
                        {
                            color:['#888383'],

                            type: 'pie',
                            radius: '60%',
                            center:['50%','50%'],
                            data: [
                                {value: that.targetdatatotle, name: 'Totle'},
                            ],
                            emphasis: {
                                scale: false
                            },
                            label:{
                                show:false
                            }
                        },
                        {
                          itemStyle:{
                              borderWidth:1,
                              borderColor:'#fff'
                            },
                            type: 'pie',
                            radius: ['50%', '80%'],
                            center:['50%','50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                fontSize:12,
                                textAlign:'center',
                                formatter: `{b}: {c}`
                            },
                            labelLine: {
                                show: true,
                                length: 35,
                                length2: 10,
                            },
                            data: mockData
                        }
                    ]
                };
              var myChart = this.$refs.echartTarget;
              myChart.chart.on('mouseover', function (params) {
                that.TargetOptions.graphic[0]['style']['text']=params.data.name.split(' ').join('\n');
                that.TargetOptions.graphic[1]['style']['text']=params.data.value;
              });
              myChart.chart.on('mouseout', function (params) {
                that.TargetOptions.graphic[0]['style']['text']='Totle';
                that.TargetOptions.graphic[1]['style']['text']=that.targetdatatotle;
              });
              myChart.chart.on('click', function (params) {
                if(params.name!="Totle"){
                  that.getSearchContent(params.name);
                }
                
              });
    },
    renderWorldChart() {
      var that=this;
      var mockData = that.worddata;
      that.worldOptions ={
                      series: [{
                        type: 'wordCloud',
                        layoutAnimation: true,
                        textStyle: {
                            fontFamily: 'sans-serif',
                            fontWeight: 'bold',
                            // Color can be a callback function or a color string
                            color: function () {
                                var colors = ['#fda67e', '#81cacc', '#cca8ba', '#88cc81', '#82a0c5', '#fddb7e', '#735ba1', '#bda29a', '#6e7074', '#546570', '#c4ccd3']
                                return colors[parseInt(Math.random() * 10)];
                            }
                        },
                        data:mockData
                      }]
                };
              var myChart = this.$refs.wordechart;
    },
    async gettjData() {
      //靶点分类查询详情
        var that = this;
        let Categorylist = '/action/edcvutvdjskzkglfz/tjdata';
        await api.getTableData(Categorylist, JSON.stringify({})).then(res => {
          if (res.data) {
            that.tjdata=res.data.tjdata;
            that.Targetdata=res.data.targetdata;
            that.worddata=res.data.worddata;
            that.targetdatatotle=res.data.targetdatatotle;
            that.keggKeydatatotle=res.data.keggKeydatatotle;
            that.renderPieChart();
            that.renderTargetChart();
            that.renderWorldChart();
          }
        });
        
    }
  }
}
</script>
<style scoped>
#complex_3d {
  width: 100%;
  height: 400px;
  position: relative;
}

.hight {
  color: blue
}

.hight a {
  color: blue
}

.text-warning {
    color: #ffc107!important;
}

.product_info_details{
    background: #fff;
    width: 80%;
    border-radius: 10px;
    margin: auto;
    padding: 0px;
}

.echarts{
    width: 100%;
    height: 100%;
}

.footer_copyright span{
  text-align: center;
    width: 100%;
}

.bodyBottom {
  width:25%;
  margin-left:10px;
  cursor:pointer;
}

.bottomFirst {
  width:25%;
  text-align: right;
  
}

.bottomFirst span {
  display:block;
  font-size: 25px;
  margin-bottom:25px;
}

.bodyBottom span {
  display:block;
  line-height:20px;
  font-size:16px;
}

.bodyBottomT {
  width:25%;
  margin-left:10px;
  cursor:pointer;
}

.bodyBottomT span {
  display:block;
  line-height:20px;
  font-size:16px;
}

.backgroundT {
  background-color:#888383;
  height:30px;
  width:100%
}

.bottomS {
  display: flex;
  flex-direction: row;
  padding-bottom:10px;
  margin-top: 10px;
}

.sTop {
  text-align: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color:#2c99ce;
  color: #fff;
}

.product_info_details .product_baseinfo {
    margin: 20px 25px 20px 25px;
    display:flex;
    flex-direction: row;
    height:500px;
    border-top: 0px solid #e0e0e0;
}

.product_info_details .product_baseinfo label{
    width: 33%;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    text-align: center;
    line-height: 500px;
}

</style>


// WEBPACK FOOTER //
// src/views/Statistics.vue